import React, {useMemo} from 'react';
import {ThemeProvider, Box} from '@mui/material';
import NavBar from '../../../pieces/navbar/navbar';
import myTheme from '../../../styles/myStyles';
import DisplayListsPageWrapper from '../../wrappers/displayListsPageWrapper';
import ListPageHeader from '../../../pieces/listPageHeader';
import {ListViewHeader} from '../../jobs/components/listViewHeader';
import usePagination from '../../../hooks/usePagination';
import {useGridViewState} from '../../../hooks/useGridViewState';
import base_url from '../../../baseUrls';
import AiDoNotCallsGrid, {getAiDoNotCallsGridAdditionalButtons} from './aiDoNotCallsGrid';

export const AiDoNotCalls = () => {
  const viewController = useGridViewState();
  const pagination = usePagination();

  const fetchParams = useMemo(
    () => ({
      url: `${base_url.api}ai/do-not-calls`,
      respKey: 'aiDoNotCalls',
      options: {},
    }),
    [],
  );

  const getHeaderComponent = () => {
    let title = 'Do Not Call';
    if (pagination.totalItemsCount) {
      title = `${title} (${pagination.totalItemsCount})`;
    }
    return (
      <ListViewHeader
        title={title}
        pagination={pagination}
        viewController={viewController}
      />
    );
  };

  const headerComponent = (
    <ListPageHeader
      viewController={viewController}
      headComponent={getHeaderComponent()}
      showAddButton={false}
      totalItems={pagination.totalItemsCount}
      additionalButtons={getAiDoNotCallsGridAdditionalButtons(viewController)}
    >
      {pagination.ItemsController}
    </ListPageHeader>
  );

  return viewController.RenderElement(
    <>
      <NavBar />
      <ThemeProvider theme={myTheme}>
        <Box sx={{height: '100%'}}>
          <DisplayListsPageWrapper headerComponent={headerComponent}>
            <AiDoNotCallsGrid viewController={viewController} pagination={pagination} fetchParams={fetchParams} />
            {pagination.PageController}
          </DisplayListsPageWrapper>
        </Box>
      </ThemeProvider>
    </>,
  );
};
